import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Error = ({
  height = 24,
  width = 24,
  color = '#BF3144',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.025 5.21277L10.8449 11.8328H9.15529L8.97063 5.21277H11.025ZM10.0001 14.7873C9.69542 14.7873 9.43382 14.6796 9.21531 14.4642C8.99679 14.2457 8.88908 13.9841 8.89215 13.6794C8.88908 13.3778 8.99679 13.1193 9.21531 12.9038C9.43382 12.6884 9.69542 12.5807 10.0001 12.5807C10.2925 12.5807 10.5495 12.6884 10.7711 12.9038C10.9927 13.1193 11.105 13.3778 11.1081 13.6794C11.105 13.8825 11.0511 14.0687 10.9465 14.238C10.8449 14.4042 10.711 14.5381 10.5449 14.6396C10.3787 14.7381 10.1971 14.7873 10.0001 14.7873Z"
        fill={getColor(color, isColorInherited)}
      />
      <rect x="1" y="1" width="18" height="18" rx="9" stroke="#BF3144" strokeWidth="2" />
    </svg>
  </SvgIcon>
);
